import React from 'react';

export function Input({ label, error, className = '', ...props }) {
  return (
    <div className={className}>
      {label && <label className="form-label">{label}</label>}
      <input className={`form-input ${error ? 'border-red-400 focus:ring-red-400' : ''}`} {...props} />
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

export function Select({ label, error, options = [], placeholder, className = '', ...props }) {
  return (
    <div className={className}>
      {label && <label className="form-label">{label}</label>}
      <select className={`form-input bg-white ${error ? 'border-red-400' : ''}`} {...props}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

export function Textarea({ label, error, className = '', rows = 3, ...props }) {
  return (
    <div className={className}>
      {label && <label className="form-label">{label}</label>}
      <textarea rows={rows} className={`form-input resize-none ${error ? 'border-red-400' : ''}`} {...props} />
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

export function Checkbox({ label, error, className = '', ...props }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <input type="checkbox" className="w-4 h-4 accent-red-600 rounded" {...props} />
      {label && <label className="text-sm text-gray-700 cursor-pointer">{label}</label>}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

export function FormRow({ children, className = '' }) {
  return <div className={`grid grid-cols-1 md:grid-cols-2 gap-4 ${className}`}>{children}</div>;
}

export function FormSection({ title, children }) {
  return (
    <div className="mb-6">
      {title && <h3 className="text-sm font-semibold text-gray-700 mb-3 pb-2 border-b border-gray-100">{title}</h3>}
      <div className="space-y-4">{children}</div>
    </div>
  );
}
